import { SaSet } from './types';

const dv: SaSet = {
  categories: [
    'Sterke wachtwoorden',
    'Phishing herkennen',
    'Privacy beschermen',
    'Veilig delen & back-up',
    'Reageren bij incidenten',
  ],
  items: [
    // Sterke wachtwoorden
    {
      category: 'Sterke wachtwoorden',
      text: 'Ik gebruik voor elke account een ander wachtwoord, zodat één gelekt wachtwoord niet meteen alles openzet.',
      quick: true,
    },
    {
      category: 'Sterke wachtwoorden',
      text: 'Ik kies wachtwoorden die lang en lastig te raden zijn, bijvoorbeeld een zinnetje dat alleen ik onthoud.',
    },
    {
      category: 'Sterke wachtwoorden',
      text: 'Ik gebruik een wachtwoordmanager, zodat ik niet alles uit mijn hoofd hoef te kennen.',
      quick: true,
    },
    {
      category: 'Sterke wachtwoorden',
      text: 'Ik zet tweestapsverificatie aan bij belangrijke accounts, zoals mijn mail en bankzaken.',
    },
    {
      category: 'Sterke wachtwoorden',
      text: 'Ik bewaar wachtwoorden niet op een briefje bij mijn werkplek of in een open document.',
    },
    {
      category: 'Sterke wachtwoorden',
      text: 'Ik verander een wachtwoord meteen als ik het vermoeden heb dat iemand het kent.',
    },

    // Phishing herkennen
    {
      category: 'Phishing herkennen',
      text: 'Ik bekijk een onverwachte mail eerst rustig voordat ik op een link of bijlage klik.',
      quick: true,
    },
    {
      category: 'Phishing herkennen',
      text: 'Ik herken signalen van een verdachte mail, zoals haast, dreiging of een vreemd afzenderadres.',
    },
    {
      category: 'Phishing herkennen',
      text: 'Ik vertrouw een bericht dat om mijn inloggegevens vraagt niet zomaar, ook niet als het er echt uitziet.',
      quick: true,
    },
    {
      category: 'Phishing herkennen',
      text: 'Ik controleer bij twijfel via een ander kanaal of een bericht echt van de afzender komt.',
    },
    {
      category: 'Phishing herkennen',
      text: 'Ik typ het webadres van mijn bank of werkomgeving zelf in plaats van op een link in een mail te klikken.',
    },
    {
      category: 'Phishing herkennen',
      text: 'Ik weet dat phishing ook via een appje of sms kan komen en niet alleen via mail.',
    },

    // Privacy beschermen
    {
      category: 'Privacy beschermen',
      text: 'Ik denk er even over na wat ik over mezelf en anderen online deel.',
      quick: true,
    },
    {
      category: 'Privacy beschermen',
      text: 'Ik kijk af en toe naar de privacy-instellingen van mijn apps en accounts.',
    },
    {
      category: 'Privacy beschermen',
      text: 'Ik geef apps alleen toegang tot gegevens die ze echt nodig hebben, zoals locatie of contacten.',
    },
    {
      category: 'Privacy beschermen',
      text: 'Ik gebruik op openbare wifi liever niet zomaar mijn bankzaken of gevoelige inlogpagina’s.',
      quick: true,
    },
    {
      category: 'Privacy beschermen',
      text: 'Ik vergrendel mijn telefoon en laptop, zodat een ander er niet zomaar in kan.',
    },
    {
      category: 'Privacy beschermen',
      text: 'Ik weet dat ik niet alles hoef in te vullen als een formulier ernaar vraagt.',
    },

    // Veilig delen & back-up
    {
      category: 'Veilig delen & back-up',
      text: 'Ik maak regelmatig een back-up van bestanden die ik niet wil kwijtraken.',
      quick: true,
    },
    {
      category: 'Veilig delen & back-up',
      text: 'Ik weet waar mijn back-up staat en hoe ik er weer bij kan als het nodig is.',
    },
    {
      category: 'Veilig delen & back-up',
      text: 'Ik deel een bestand of map alleen met de mensen die het echt moeten zien.',
      quick: true,
    },
    {
      category: 'Veilig delen & back-up',
      text: 'Ik controleer bij een deellink of die niet per ongeluk voor iedereen open staat.',
    },
    {
      category: 'Veilig delen & back-up',
      text: 'Ik stuur gevoelige gegevens niet zomaar in een gewone mail rond.',
    },
    {
      category: 'Veilig delen & back-up',
      text: 'Ik ruim toegang tot gedeelde bestanden op als iemand het niet meer nodig heeft.',
    },

    // Reageren bij incidenten
    {
      category: 'Reageren bij incidenten',
      text: 'Ik weet bij wie ik terecht kan als er iets misgaat, bijvoorbeeld na een verdachte klik.',
      quick: true,
    },
    {
      category: 'Reageren bij incidenten',
      text: 'Ik durf het te melden als ik denk dat ik per ongeluk iets verkeerd heb gedaan.',
    },
    {
      category: 'Reageren bij incidenten',
      text: 'Ik verander direct mijn wachtwoord als ik vermoed dat een account is gehackt.',
      quick: true,
    },
    {
      category: 'Reageren bij incidenten',
      text: 'Ik blijf rustig bij een incident en bedenk eerst welke stap het meest helpt.',
    },
    {
      category: 'Reageren bij incidenten',
      text: 'Ik koppel een apparaat los van internet als ik denk dat er iets ergs mee aan de hand is.',
    },
    {
      category: 'Reageren bij incidenten',
      text: 'Ik weet dat een melding maken meestal helpt en zelden tot gedoe leidt.',
    },
  ],
};

export default dv;
